import * as React from "react"

type ContextProps = {
  activeTraps: Map<string, string>
  setActiveTraps: React.Dispatch<React.SetStateAction<Map<string, string>>>
}

const initialContext: ContextProps = {
  activeTraps: new Map(),
  setActiveTraps: () => {}
}
const FocusContext: React.Context<ContextProps> = React.createContext(
  initialContext
)

export default FocusContext
